import { createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    ref: "anchorRef",
    class: "en-navbar-search relative w-[300px]"
};
const _hoisted_2 = {
    for: "navbar-module-search-input",
    class: "flex h-9 w-full cursor-text items-center gap-2 rounded-md border border-input bg-background px-3 text-sm shadow-xs transition-colors focus-within:ring-2 focus-within:ring-ring"
};
const _hoisted_3 = ["placeholder", "onKeydown"];
const _hoisted_4 = {
    key: 0,
    class: "flex items-center justify-center gap-2 p-4 text-muted-foreground"
};
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "mb-2 border-b border-border pb-1 text-xs font-semibold uppercase text-en-blue-400/90" };
const _hoisted_7 = ["onClick", "onMouseenter"];
const _hoisted_8 = { class: "text-muted-foreground" };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { key: 2 };
const _hoisted_11 = { class: "mb-2 border-b border-border pb-1 text-xs font-semibold uppercase text-en-blue-400/90" };
const _hoisted_12 = ["onClick", "onMouseenter"];
const _hoisted_13 = { class: "text-muted-foreground" };
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
    key: 3,
    class: "flex items-center justify-center p-4 text-muted-foreground"
};
const _hoisted_16 = {
    key: 4,
    class: "flex items-center justify-center p-4 text-muted-foreground"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["PopoverRoot"], {
        open: $setup.menu,
        "onUpdate:open": _cache[4] || (_cache[4] = ($event) => (($setup.menu) = $event))
    }, {
        default: _withCtx(() => [
            _createVNode($setup["PopoverAnchor"], null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("label", _hoisted_2, [
                            _createVNode($setup["Search"], { class: "size-4 shrink-0 text-muted-foreground" }),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.search) = $event)),
                                ref: "inputRef",
                                autocomplete: "off",
                                type: "text",
                                id: "navbar-module-search-input",
                                class: "min-w-0 flex-1 bg-transparent outline-none placeholder:text-muted-foreground",
                                placeholder: $setup.t('common.dashboard.searchPlaceholder'),
                                onFocus: _cache[1] || (_cache[1] = ($event) => ($setup.menu = true)),
                                onKeydown: [
                                    _withKeys(_withModifiers($setup.onArrowUp, ["prevent"]), ["up"]),
                                    _withKeys(_withModifiers($setup.onArrowDown, ["prevent"]), ["down"]),
                                    _withKeys(_withModifiers($setup.onEnter, ["prevent"]), ["enter"])
                                ]
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
                                [_vModelText, $setup.search]
                            ]),
                            (!$setup.menu)
                                ? (_openBlock(), _createBlock($setup["KbdShadcn"], { key: 0 }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createTextVNode("/", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true)
                        ])
                    ], 512 /* NEED_PATCH */)
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode($setup["PopoverContent"], {
                align: "end",
                class: "w-auto min-w-[var(--reka-popover-trigger-width)] p-2",
                "side-offset": 6,
                onOpenAutoFocus: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                onCloseAutoFocus: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                onFocusOutside: $setup.onOutsideInteraction,
                onPointerDownOutside: $setup.onOutsideInteraction
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" Spinner only when there are no results yet; while refetching with\r\n           results present, keep showing them so the popover doesn't flash. "),
                    ($setup.loading && !$setup.searchResults.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode($setup["Loader"], { class: "size-5 animate-spin" }),
                            _createElementVNode("span", null, _toDisplayString($setup.t('common.loading')), 1 /* TEXT */)
                        ]))
                        : ($setup.searchResults.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.t('common.moduleSearch.title')), 1 /* TEXT */),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchResults, (module, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["flex cursor-pointer items-center gap-2.5 whitespace-nowrap rounded-md p-2", { 'bg-en-blue-100/90': $setup.highlighted === i && $setup.activeListType === 'search' }]),
                                        key: 'result-' + i,
                                        onClick: ($event) => ($setup.navigateTo(module)),
                                        onMouseenter: ($event) => ($setup.highlightItem(i, 'search'))
                                    }, [
                                        _createVNode($setup["EnDashboardIconWrapper"], {
                                            small: "",
                                            icon: $setup.getModuleIcon(module),
                                            variant: $setup.EnDashboardIconVariants.Navigation
                                        }, null, 8 /* PROPS */, ["icon", "variant"]),
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(module.area), 1 /* TEXT */),
                                        _createVNode($setup["ChevronRight"], {
                                            size: 16,
                                            color: "#516F82"
                                        }),
                                        _createElementVNode("div", {
                                            class: "text-foreground",
                                            innerHTML: $setup.highlightText(module.name, $setup.search)
                                        }, null, 8 /* PROPS */, _hoisted_9)
                                    ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : (!$setup.search.trim() && $setup.recentItems.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.t('common.moduleSearch.recentlyViewed')), 1 /* TEXT */),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentItems, (module, j) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["flex cursor-pointer items-center gap-2.5 whitespace-nowrap rounded-md p-2", { 'bg-en-blue-100/90': $setup.highlighted === j && $setup.activeListType === 'recent' }]),
                                            key: 'rv-' + j,
                                            onClick: ($event) => ($setup.navigateTo(module)),
                                            onMouseenter: ($event) => ($setup.highlightItem(j, 'recent'))
                                        }, [
                                            _createVNode($setup["EnDashboardIconWrapper"], {
                                                small: "",
                                                icon: $setup.getModuleIcon(module),
                                                variant: $setup.EnDashboardIconVariants.Navigation
                                            }, null, 8 /* PROPS */, ["icon", "variant"]),
                                            _createElementVNode("div", _hoisted_13, _toDisplayString(module.area), 1 /* TEXT */),
                                            _createVNode($setup["ChevronRight"], {
                                                size: 16,
                                                color: "#516F82"
                                            }),
                                            _createElementVNode("div", {
                                                class: "text-foreground",
                                                innerHTML: $setup.highlightText(module.name, $setup.search)
                                            }, null, 8 /* PROPS */, _hoisted_14)
                                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_12));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                                : (!$setup.search.trim())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.t('common.moduleSearch.searchPrompt')), 1 /* TEXT */))
                                    : ($setup.search && !$setup.loading && !$setup.searchResults.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.t('common.moduleSearch.noSearchResults')), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]));
}
